var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", wrap: "" } },
    [
      _c("v-flex", { attrs: { xs12: "", md12: "" } }, [
        _c("div", { staticClass: "pie-wrapper" }, [
          _c("h1", { staticClass: "top-text" }, [_vm._v("Today")]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "pie",
              class: _vm.pieClicked === "Day" ? "pieClicked" : "",
              style: _vm.bggradientDay,
              on: {
                click: function($event) {
                  ;(_vm.bggradient = _vm.bggradientDay),
                    (_vm.wrapper2Text = "Today's Sales"),
                    (_vm.salesOnClick = _vm.sales.today),
                    (_vm.userwiseSales = _vm.userwiseSalesDay),
                    (_vm.manualOrderTotal = _vm.manualOrderTotalDay),
                    (_vm.onlineOrderTotal = _vm.onlineOrderTotalDay),
                    (_vm.pieClicked = "Day"),
                    (_vm.showDetails = true)
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "txt" },
                [
                  !_vm.loadingToday
                    ? _c("span", [_vm._v(" " + _vm._s(_vm.sales.today))])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.loadingToday
                    ? _c(
                        "v-layout",
                        { attrs: { "justify-center": "", "align-center": "" } },
                        [
                          _c("v-progress-circular", {
                            attrs: { indeterminate: "", color: "primary" }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "pie-wrapper" }, [
          _c("h1", { staticClass: "top-text" }, [_vm._v("WTD")]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "pie",
              class: _vm.pieClicked === "Week" ? "pieClicked" : "",
              style: _vm.bggradientWeek,
              on: {
                click: function($event) {
                  ;(_vm.bggradient = _vm.bggradientWeek),
                    (_vm.wrapper2Text = "WTD Sales"),
                    (_vm.salesOnClick = _vm.sales.week),
                    (_vm.userwiseSales = _vm.userwiseSalesWeek),
                    (_vm.manualOrderTotal = _vm.manualOrderTotalWeek),
                    (_vm.onlineOrderTotal = _vm.onlineOrderTotalWeek),
                    (_vm.pieClicked = "Week"),
                    (_vm.showDetails = true)
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "txt" },
                [
                  !_vm.loadingWeek
                    ? _c("span", [_vm._v(" " + _vm._s(_vm.sales.week))])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.loadingWeek
                    ? _c(
                        "v-layout",
                        { attrs: { "justify-center": "", "align-center": "" } },
                        [
                          _c("v-progress-circular", {
                            attrs: { indeterminate: "", color: "primary" }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "pie-wrapper" }, [
          _c("h1", { staticClass: "top-text" }, [_vm._v("MTD")]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "pie",
              class: _vm.pieClicked === "Month" ? "pieClicked" : "",
              style: _vm.bggradientMonth,
              on: {
                click: function($event) {
                  ;(_vm.bggradient = _vm.bggradientMonth),
                    (_vm.wrapper2Text = "MTD Sales"),
                    (_vm.salesOnClick = _vm.sales.month),
                    (_vm.userwiseSales = _vm.userwiseSalesMonth),
                    (_vm.manualOrderTotal = _vm.manualOrderTotalMonth),
                    (_vm.onlineOrderTotal = _vm.onlineOrderTotalMonth),
                    (_vm.pieClicked = "Month"),
                    (_vm.showDetails = true)
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "txt" },
                [
                  !_vm.loadingMonth
                    ? _c("span", [_vm._v(" " + _vm._s(_vm.sales.month))])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.loadingMonth
                    ? _c(
                        "v-layout",
                        { attrs: { "justify-center": "", "align-center": "" } },
                        [
                          _c("v-progress-circular", {
                            attrs: { indeterminate: "", color: "primary" }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "pie-wrapper" }, [
          _c("h1", { staticClass: "top-text" }, [_vm._v("QTD")]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "pie",
              class: _vm.pieClicked === "Quarter" ? "pieClicked" : "",
              style: _vm.bggradientQuarter,
              on: {
                click: function($event) {
                  ;(_vm.bggradient = _vm.bggradientQuarter),
                    (_vm.wrapper2Text = "QTD Sales"),
                    (_vm.salesOnClick = _vm.sales.quarter),
                    (_vm.userwiseSales = _vm.userwiseSalesQuarter),
                    (_vm.manualOrderTotal = _vm.manualOrderTotalQuarter),
                    (_vm.onlineOrderTotal = _vm.onlineOrderTotalQuarter),
                    (_vm.pieClicked = "Quarter"),
                    (_vm.showDetails = true)
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "txt" },
                [
                  !_vm.loadingQuarter
                    ? _c("span", [_vm._v(" " + _vm._s(_vm.sales.quarter))])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.loadingQuarter
                    ? _c(
                        "v-layout",
                        { attrs: { "justify-center": "", "align-center": "" } },
                        [
                          _c("v-progress-circular", {
                            attrs: { indeterminate: "", color: "primary" }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "pie-wrapper" }, [
          _c("h1", { staticClass: "top-text" }, [_vm._v("YTD")]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "pie",
              class: _vm.pieClicked === "Year" ? "pieClicked" : "",
              style: _vm.bggradientYear,
              on: {
                click: function($event) {
                  ;(_vm.bggradient = _vm.bggradientYear),
                    (_vm.wrapper2Text = "YTD Sales"),
                    (_vm.salesOnClick = _vm.sales.year),
                    (_vm.userwiseSales = _vm.userwiseSalesYear),
                    (_vm.manualOrderTotal = _vm.manualOrderTotalYear),
                    (_vm.onlineOrderTotal = _vm.onlineOrderTotalYear),
                    (_vm.pieClicked = "Year"),
                    (_vm.showDetails = true)
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "txt" },
                [
                  !_vm.loadingYear
                    ? _c("span", [_vm._v(" " + _vm._s(_vm.sales.year))])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.loadingYear
                    ? _c(
                        "v-layout",
                        { attrs: { "justify-center": "", "align-center": "" } },
                        [
                          _c("v-progress-circular", {
                            attrs: { indeterminate: "", color: "primary" }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _vm.showDetails && _vm.$route.name === "Dashboard"
        ? _c("v-flex", { attrs: { xs12: "", md8: "", m0a: "" } }, [
            _c(
              "div",
              { staticClass: "pie-wrapper2" },
              [
                _c("h1", { staticClass: "top-text" }, [
                  _vm._v(_vm._s(_vm.wrapper2Text))
                ]),
                _vm._v(" "),
                _c(
                  "v-layout",
                  { attrs: { row: "", wrap: "" } },
                  [
                    _vm.manualOrderTotal
                      ? _c(
                          "v-flex",
                          {
                            staticStyle: { "text-align": "right" },
                            attrs: { xs12: "", md5: "" }
                          },
                          [
                            _c("div", [
                              _c("h1", { staticClass: "top-text2" }, [
                                _vm._v("Team Breakdown")
                              ])
                            ]),
                            _vm._v(" "),
                            _vm._l(this.userwiseSales, function(order, user) {
                              return _c("div", { key: user }, [
                                _c("h1", { staticClass: "top-text2" }, [
                                  _vm._v(
                                    _vm._s(order[0]) +
                                      " - $" +
                                      _vm._s(order[1].toLocaleString())
                                  )
                                ])
                              ])
                            })
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.manualOrderTotal
                      ? _c("v-flex", { attrs: { xs12: "", md2: "" } }, [
                          _c("div", { staticClass: "tb" })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      {
                        class: _vm.manualOrderTotal ? "md5" : "md12",
                        attrs: { xs12: "" }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "pie", style: _vm.bggradient },
                          [
                            _c("div", { staticClass: "txt txt2" }, [
                              _c("div", { staticStyle: { width: "50%" } }, [
                                _vm._v("$" + _vm._s(_vm.manualOrderTotal))
                              ]),
                              _vm._v(" "),
                              _c("div", { staticStyle: { width: "50%" } }, [
                                _vm._v("$" + _vm._s(_vm.onlineOrderTotal))
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "txt txt3" },
                              [
                                !_vm.loadingToday
                                  ? _c("span", [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.salesOnClick) +
                                          "\n              "
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.loadingToday
                                  ? _c(
                                      "v-layout",
                                      {
                                        attrs: {
                                          "justify-center": "",
                                          "align-center": ""
                                        }
                                      },
                                      [
                                        _c("v-progress-circular", {
                                          attrs: {
                                            indeterminate: "",
                                            color: "primary"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.$route.name === "AccountDashboard"
        ? _c("v-flex", { attrs: { xs12: "", md8: "", m0a: "" } }, [
            _c(
              "div",
              { staticClass: "pie-wrapper3" },
              [
                _c("h1", { staticClass: "top-text" }, [
                  _vm._v("Outstanding Balances")
                ]),
                _vm._v(" "),
                _c(
                  "v-layout",
                  { attrs: { row: "", wrap: "" } },
                  [
                    _c("v-flex", { staticClass: "md12", attrs: { xs12: "" } }, [
                      _c(
                        "div",
                        {
                          staticClass: "pie",
                          staticStyle: {
                            "background-image":
                              "conic-gradient(#565e6f 50%, #565e6f 50%)"
                          }
                        },
                        [
                          _c("div", { staticClass: "txt txt2" }),
                          _vm._v(" "),
                          _c("div", { staticClass: "txt" }, [
                            _c("span", [
                              _vm._v(
                                "\n                $" +
                                  _vm._s(_vm.outStandingSales) +
                                  "\n              "
                              )
                            ])
                          ])
                        ]
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d9ef65f0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d9ef65f0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DashboardSales.vue
// module id = null
// module chunks = 